import { TextField, TextFieldProps, withStyles } from '@material-ui/core';
import React from 'react';

type OutlinedProps = Omit<TextFieldProps, 'variant'>;

interface IOutlinedTextFieldProps extends OutlinedProps {}

interface IOutlinedTextFieldState {}


export default class OutlinedTextField extends React.PureComponent<IOutlinedTextFieldProps, IOutlinedTextFieldState> {
    constructor(props : IOutlinedTextFieldProps) {
        super(props);
        this.state = {};
    }

    private readonly OutlinedTextField = withStyles({
        root: {
            '& input + fieldset': {
                borderColor: '#707070',
                borderWidth: 1,
                borderRadius: 4,
            },
        },
    })(TextField);

    public readonly render = () => {
        const { ...rest } = this.props;
        return (
            <this.OutlinedTextField
                {...rest}
                variant='outlined'
            />
        );
    };
}

